document.addEventListener(
    "DOMContentLoaded",
    () => {
        // mmOpenCart();
    },
    { once: true }
);

function debounce(func, duration) {
    let timeout;
    return function (...args) {
        const effect = () => {
            timeout = null;
            return func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(effect, duration);
    };
}

/*********************************************************************************************
 * Get the cart section element from the DOM.
 *
 * @returns {HTMLElement} - The cart section element.
 */
function mmCartSectionElement() {
	return document.getElementById(`${mmCartSectionIdLong()}`);
}

/*********************************************************************************************
 * Get the cart product container element from the cart section.
 *
 * @returns {HTMLElement} - The cart product container element.
 */
function mmCartProductsContainerElement() {
	return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

function mmCartItem(line_index) {
    return mmCartProductsContainerElement().querySelector(`[data-line-index="${line_index}"]`);
}

function mmCartItemQuantityEl(line_index) {
    const itemEl = mmCartItem(line_index);
    return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(line_index) {
    const itemEl = mmCartItem(line_index);
    const quantityEl = mmCartItemQuantityEl(line_index);

    return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(line_index, newQuantity) {
    // Display qtty in front
    if (newQuantity >= 0) {
        const quantityEl = mmCartItemQuantityEl(line_index);

        quantityEl.dataset.itemQuantity = newQuantity;
        quantityEl.innerText = newQuantity;
    }
}

function mmAPIRequest(method, path, body) {
    document.querySelector(".mm-dc-products")?.classList?.add("mm-inactive");
    return fetch(window.Shopify.routes.root + path, {
        method: method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
    })
    .then((response) => response.json())
    .then((data) => {
        document.querySelector(".mm-dc-products")?.classList?.remove("mm-inactive");
        updateCartCount(data.item_count != null ? data.item_count : 0);
        if (data.status && data.status > 400) {
            throw data;
        } else {
            return data;
        }
    });
}

/*********************************************************************************************
 * Open the cart drawer and fetch the latest cart data.
 */
function mmOpenCart() {
	const cartFilter = document.querySelector(".mm-drawer-cart-wrapper");
	const html = document.querySelector("html");

    console.log('cartFilter', cartFilter)

	if (!cartFilter || !html) return;

	cartFilter.classList.add("mm-dc-is-open");
	html.classList.add("stop-scrolling");

	// Fetch latest cart data
	mmAPIRequest("GET", `cart.js?sections=${mmCartSectionId()}`)
		.then(refreshCartFromData)
		.catch((error) => {
			console.error("Erreur lors de l'ouverture du panier:", error);
		});
}

// Fermer le panier
function mmCloseCart() {
    document.querySelector(".mm-drawer-cart-wrapper").classList.remove("mm-dc-is-open");
    document.querySelector("html").classList.remove("stop-scrolling");
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
    const newCartEl = document.createElement("DIV");
	newCartEl.innerHTML = data.sections[mmCartSectionId()];
    const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-wrapper");

    var showCrossSell = false;
    if (innerCart.querySelector('.mm-dc-left').classList.contains('mm-visible')) {
		showCrossSell = true;
    }

    innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-wrapper").innerHTML;
    if(showCrossSell) {
		innerCart.querySelector('.mm-dc-left').classList.add('mm-visible');
		innerCart.querySelector('.mm-cart-cross-sell-filter').classList.add('mm-visible');      
    }
    mmInitSplide();
    return data;
}

// Ajouter un item au panier avec une propriété
function mmAddProductToCartWithProperty(variantId, parentId) {
    mmAPIRequest("POST", "cart/add.js", {
        items: [{ 
			quantity: 1, 
			id: variantId,
			properties: {
				'_parent_product': parentId
			}
        }],
		sections: mmCartSectionId(),
    })
    .then(refreshCartFromData)
    .then((data) => {
    })
    .catch((error) => {
        alert(error.message)
        console.log(error);  
        location.reload();
    });
}

// Ajouter un item au panier
function mmAddProductToCart(variantId, { quantity = 1, openCart = true }) {
    mmAPIRequest("POST", "cart/add.js", {
        items: [{ quantity: quantity, id: variantId }],
		sections: mmCartSectionId(),
    })
    .then(refreshCartFromData)
    .then((data) => {
        if (openCart) {
            setTimeout(mmOpenCart);
        }
    })
    .catch((error) => {
        alert(error.message)
        mmOpenCart();
        console.log(error);  
        location.reload();
    });
}

function mmAddProductWithUpsellToCart(parentVariantId, upsellVariantId, { parent_quantity = 1, openCart = true }) {
    mmAPIRequest("POST", "cart/add.js", {
        items: [
          { 
            id: parentVariantId,
            quantity: parent_quantity
          },
          { 
            id: upsellVariantId,
            quantity: 1, 
            properties: {
              '_parent_product': parentVariantId              
            }
          }
        ],
		sections: mmCartSectionId(),
    })
    .then(refreshCartFromData)
    .then((data) => {
        if (openCart) {
            setTimeout(mmOpenCart);
        }
    })
    .catch((error) => {
        alert(error.message)
        mmOpenCart();
        console.log(error);  
        location.reload();
    });
  
}

function mmAddProductToCartFromProductFrom() {
// 1: on regarde si la checkbox de cross-sell existe, si oui on regarde si elle est checked

const upsellMetafieldElement = document.getElementById('upsell-metafield');

// Si l'élément existe, vérifier le dataset
if (upsellMetafieldElement && upsellMetafieldElement.dataset.upsell) {
  // Récupérer la valeur du metafield upsell
  const upsellMetafield = upsellMetafieldElement.dataset.upsell;
    console.log("Le metafield product_upsell n'est pas vide:", upsellMetafield);

    // Logique d'ajout au panier
    const checkbox = document.querySelector('.mm-container-product-form .mm-check-upsell');
    const variant_id = document.getElementById('product_id').value;
    const variant_quantity = document.getElementById('mm-quantity-main-product').value;
  
    if (checkbox) {
      if (checkbox.checked) {
        const upsell_variant_id = checkbox.dataset.variantId;
        mmAddProductWithUpsellToCart(variant_id, upsell_variant_id, { parent_quantity: variant_quantity, openCart: true });
      } else {
		const checkbox = document.querySelector('.mm-container-product-form .mm-check-upsell');
		const variant_id = document.getElementById('product_id').value;
		const variant_quantity = document.getElementById('mm-quantity-main-product');
        mmAddProductToCart(variant_id, { quantity: variant_quantity.value, openCart: true });
      }
    }
  } else {
	const checkbox = document.querySelector('.mm-container-product-form .mm-check-upsell');
	const variant_id = document.getElementById('product_id').value;

	const variant_quantity = document.getElementById('mm-quantity-main-product');

	console.log('variant', variant_id)
	console.log('quantity', variant_quantity)

	mmAddProductToCart(variant_id, { quantity: variant_quantity.value, openCart: true });
  }
}

function mmIncreaseProductQuantity(line_index) {
    const quantity = mmGetCartItemQuantity(line_index);
    const newQuantity = quantity + 1;
    mmSetCartItemQuantity(line_index, newQuantity);

    mmDebouncedPushNewQuantity(line_index);
}

function mmDecreaseProductQuantity(line_index) {
    const quantity = mmGetCartItemQuantity(line_index);
    const newQuantity = quantity - 1;
    mmSetCartItemQuantity(line_index, newQuantity);

    mmDebouncedPushNewQuantity(line_index);
}

function mmDestroyProductFromCart(productVariantId) {
    const newQuantity = 0;
    mmSetCartItemQuantity(line_index, newQuantity);

    mmDebouncedPushNewQuantity(line_index);
}

/*********************************************************************************************
 * Push the new quantity of a specific product to the server.
 *
 * @param {number} line_index - The line item index.
 */
function mmPushNewQuantity(line_index) {
	const quantity = mmGetCartItemQuantity(line_index);
	mmAPIRequest("POST", "cart/change.js", {
		line: line_index,
		quantity: quantity,
		sections: mmCartSectionId(),
	})
		// .then(mmAddOrRemoveFreeProducts)
		.then(refreshCartFromData)
		.then((data) => {})
		.catch((error) => {
			alert(error.message);
			console.log(error);
			location.reload();
		});
}
const mmDebouncedPushNewQuantity = debounce(function (line_index) {
    mmPushNewQuantity(line_index);
}, 300);


function updateCartCount(value) {
  const bubble = document.querySelector(".mm-cart-count-bubble");
  
   if (value > 0) {
      bubble.classList.remove("mm-none");
      bubble.innerText = value;
   } else {
      bubble.classList.add("mm-none");
   }
}

/*********************************************************************************************
 * Remove a line item from the cart.
 *
 * @param {number|string} line_index - The index of the line item in the cart to be removed.
 */
function mmDestroyLineItemFromCart(line_index) {
	mmAPIRequest("POST", "cart/change.js", {
		line: parseInt(line_index),
		quantity: 0,
		sections: mmCartSectionId(),
	}).then(refreshCartFromData);
}

function mmDestroyLineItemsFromCart(line_index_1, line_index_2) {

    mmAPIRequest("POST", "cart/change.js", {
        line: parseInt(line_index_1),
        quantity: 0,
		sections: mmCartSectionId(),
    })
    .then(() => {
      return mmAPIRequest("POST", "cart/change.js", {
        line: parseInt(line_index_2),
        quantity: 0,
		sections: mmCartSectionId(),
      })
    })
    .then(refreshCartFromData);
}

function mmProductUpsellIn(inputElem, variantId, parentId) {
  if(inputElem.checked) {
    mmAddProductToCartWithProperty(variantId, parentId);
  } else {
    mmDestroyLineItemFromCart(inputElem.dataset.line);
  }
}

function mmCartShowCrossSell() {
	const filter = document.querySelector('.mm-cart-cross-sell-filter');
	filter.classList.add('mm-visible');

	const slideUp = document.querySelector('.mm-dc-left');
	slideUp.classList.add('mm-visible');
	slideUp.style.bottom = "0";
}

function mmCartHideCrossSell() {
	const filter = document.querySelector('.mm-cart-cross-sell-filter');
	filter.classList.remove('mm-visible');

	const slideUp = document.querySelector('.mm-dc-left');
	slideUp.style.bottom = "-110%";
}




/*********************************************************************************************
 * Get the full cart section ID from the DOM.
 *
 * @returns {HTMLElement} - The full cart section ID with the prefix.
 */
function mmCartSectionIdLong() {
	return document.querySelector(".mm-cart").id;
}

/*********************************************************************************************
 * Get the cart section ID from the DOM, removing the "shopify-section-" prefix.
 *
 * @returns {HTMLElement} - The cart section ID without the "shopify-section-" prefix.
 */
function mmCartSectionId() {
	return document.querySelector(".mm-cart").id.replace("shopify-section-", "");
}